import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Col,
  Row,
  Card,
  Button,
  Modal,
  Form,
  InputGroup,
  FormControl,
  FormLabel,
  FormGroup,
  Alert,
  Container,
} from "react-bootstrap";
import styles from "./ConfirmarRegistroCuenta.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { ConsultaWS, ConsultaWSGet } from "../Commons/ServiciosBase";
import ConfirmMessage from "../General/ConfirmMessage";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";
import BarraLoader from "../General/BarraLoader";
import { decryptBase64ArrayByteToString } from "../Commons/EncriptText";
import {
  ValidarPreRegistroRest_Respuesta,
  ValidarPreRegistroRest_Parametros,
  ValidarPreRegistroRest_Entrada,
  builtValidarPreRegistroInput,
} from "../Commons/Services/ConfirmacionRegistroCuenta/ValidarPreRegistroRest";

import {
  CrearRegistroRest_Respuesta,
  CrearRegistroRest_Parametros,
  CrearRegistroRest_Entrada,
  builtCrearRegistroSelInputMessage,
} from "../Commons/Services/ConfirmacionRegistroCuenta/CrearRegistroRest";

import Loading from "../General/Loading";
import { stat } from "fs";

import encryptText from "../Commons/EncriptText";
import { useCallback } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const { REACT_APP_CAPTCHA_KEY } = process.env;

export const ConfirmarRegistroCuenta = () => {
  const captchaRef = useRef<ReCAPTCHA>(null);
  const [capchaToken, setCapchaToken] = useState<string>("");

  //Mensajes de notificaciones
  const SUCCESS_MESSAGE =
    "Has creado tu cuenta, ingresa desde el login con tu nuevo usuario y contraseña";
  const ERROR_MESSAGE =
    "No se completo el registro, por favor comunicarse a servicios en línea";
  const GENERIC_ERROR_MESSAGE =
    "El link de registro es inválido o su código de verificación es incorrecto, por favor comuniquese a los teléfonos de SKY";
  const PROCESADO_MESSAGE =
    "El código de verificación indica que ya se encuentra registrado en el sistema, si no puede ingresar intente con la opción de recuperación de contraseña.";
  const EXPIRADO_MESSAGE =
    "El registro ha caducado, para poder ingresar a servicios en línea deberá registrarse nuevamente.";
  const VIGENTE_MESSAGE = "Terminando Registro para el Código ";

  const [disable, setDisable] = useState(false);
  const [notificacion, setNotificacion] = useState(GENERIC_ERROR_MESSAGE);
  const [idPre, setIdPre] = useState("");
  const { code } = useParams(); // se obtienen parametros encriptados de la url de soa
  const attrCodeType: string | undefined = "";
  const [attrsCode, setAttrsCode] = useState({
    IdPreReg: attrCodeType,
    Cuenta: attrCodeType,
    Password: attrCodeType,
    Email: attrCodeType,
    Telf: attrCodeType,
    Servicio: attrCodeType,
    Tipo: attrCodeType,
  });
  const [loading, isLoading] = useState(false);
  const [acepta, setAcepta] = useState(false);
  const [validaPasswordVacio, setValidaPasswordVacio] = useState(false);
  const [validaConfirmarContraseniaVacio, setValidaConfirmarContraseniaVacio] =
    useState(false);
  const [vPasswordMessage, setVPasswordMessage] = useState("");
  const [vConfirmPwdMessage, setVConfirmPwdMessage] = useState("");
  const { REACT_APP_CAPTCHA_KEY } = process.env;

  const stylos = {
    borderMail: {
      border: validaPasswordVacio ? "solid 1px red" : "transparent",
      borderRadius: "2px",
    },
    borderMobile: {
      border: validaConfirmarContraseniaVacio ? "solid 1px red" : "transparent",
      borderRadius: "2px",
    },
  };

  const [aceptarExito, setAceptarExito] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleRedirect = () => {
    setShow(false);
    navigate("/sky/login");
  };

  const handleShow = () => {
    setShow(true);
  };
  const [showModule, setShowModule] = useState(true);
  const [errorCredenciales, setErrorCredenciales] = useState(false);
  const [statusError, setStatusError] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [usuarioPlaceholder, setUsuarioPlaceholder] = useState("");
  const [imagenURI, setImagenURI] = useState(logo);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [account, setAccount] = useState("");

  const [status, setStatus] = useState({
    show: false,
    color: "red",
    message: "",
  });

  const [typePwd, setTypePwd] = useState("password");

  const navigate = useNavigate();

  const pwdValido = (pwd: string) => {
    let validExpPass: RegExp =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!#%*?&])[A-Za-z\d$@$!#%*?&]{8,15}/;

    return validExpPass.test(pwd);
  };

  const setFieldValue = (e: any, campo: string) => {
    if (campo === "password") {
      setPassword(e);
    }

    if (campo === "confirmPassword") {
      setConfirmPassword(e);
    }
  };

  const validarCampo = (e: any, campo: string) => {
    if (campo === "password") {
      if (e === "") {
        setValidaPasswordVacio(true);
        setVPasswordMessage("La contraseña es requerida");
        return false;
      }
      if (!pwdValido(e)) {
        setValidaPasswordVacio(true);
        setVPasswordMessage(
          "La contraseña no cumple con los requisitos establecidos"
        );
        return false;
      } else {
        setValidaPasswordVacio(false);
        return true;
      }
    }

    if (campo === "confirmPassword") {
      if (e === "") {
        setValidaConfirmarContraseniaVacio(true);
        setVConfirmPwdMessage("Es requerido Confirmar la contraseña");
        return false;
      }
      if (!pwdValido(e)) {
        setValidaConfirmarContraseniaVacio(true);
        setVConfirmPwdMessage(
          "La contraseña no cumple con los requisitos establecidos"
        );
        return false;
      } else {
        if (password != confirmPassword) {
          setValidaPasswordVacio(true);
          setVPasswordMessage(
            "La contraseña y la confirmación de la contraseña deben coincidir"
          );
          return false;
        } else {
          setValidaConfirmarContraseniaVacio(false);
          return true;
        }
      }
    }
  };

  const handleSubmit = async () => {
    setStatus({ show: false, color: "red", message: "" });

    if (validarCampo(password, "password")) {
      if (validarCampo(password, "confirmPassword")) {
        if (password === "" || confirmPassword === "") {
          if (password === "") {
            setValidaPasswordVacio(true);
            setVPasswordMessage("La Contraseña es requerida");
          } else {
            setValidaPasswordVacio(false);
          }

          return;
        } else {
          isLoading(true);

          doRegistrarCuentaRest(encryptText(password));
        }
      }
    }
  };

  const getValueDecrypterByKey = (codeDecryp: string, key: string) => {
    let cadena = codeDecryp.split(",");
    let value;

    try {
      cadena.map((element) => {
        element = element.trim();
        if (element.split("=")[0] == key) {
          value = element.split("=")[1];
          return;
        }
      });
    } catch (error) {
      console.error(error);
    }

    if (key == "TipoCuenta" && value != undefined) {
      let valStr: string = value;
      value = valStr.slice(0, 1);
    }

    return value != undefined ? value : "";
  };

  const validateURL = () => {
    isLoading(true);
    let codeDecryp: string = "";

    try {
      //Completa el registro de Pre-registro

      codeDecryp = decryptBase64ArrayByteToString(code).trim();

      let IdPre = getValueDecrypterByKey(codeDecryp, "IdPre");

      //Valida que haya pre-registro
      doValidarPreRegistro(IdPre);
      isLoading(false);
    } catch (error) {
      setNotificacion(GENERIC_ERROR_MESSAGE);
      setDisable(true);
      isLoading(false);
      handleShow();
      return;
    }
  };

  const doRegistrarCuentaRest = async (pwd: string) => {
    let codeDecryp: string = "";
    codeDecryp = decryptBase64ArrayByteToString(code).trim();

    let IdPre = getValueDecrypterByKey(codeDecryp, "IdPre");
    setAttrsCode({
      IdPreReg: IdPre,
      Cuenta: getValueDecrypterByKey(codeDecryp, "NumeroCuenta"),
      Password: pwd,
      Email: getValueDecrypterByKey(codeDecryp, "Email"),
      Telf: getValueDecrypterByKey(codeDecryp, "Tel"),
      Servicio: getValueDecrypterByKey(codeDecryp, "Servicio"),
      Tipo: getValueDecrypterByKey(codeDecryp, "TipoCuenta"),
    });

    const CrearRegistroRestDO: CrearRegistroRest_Entrada =
      builtCrearRegistroSelInputMessage(
        IdPre,
        getValueDecrypterByKey(codeDecryp, "NumeroCuenta"),
        pwd,
        getValueDecrypterByKey(codeDecryp, "Email"),
        getValueDecrypterByKey(codeDecryp, "Tel"),
        getValueDecrypterByKey(codeDecryp, "Servicio"),
        getValueDecrypterByKey(codeDecryp, "TipoCuenta")
      );

    let par = CrearRegistroRest_Parametros(CrearRegistroRestDO, capchaToken);
    let CrearRegistroRest_Respuesta: CrearRegistroRest_Respuesta =
      await ConsultaWS(par);
    if (
      CrearRegistroRest_Respuesta.EBMHeaderResponse &&
      CrearRegistroRest_Respuesta.EBMHeaderResponse.ErrorTecnico.code === "ok"
    ) {
      if (
        CrearRegistroRest_Respuesta.EBMHeaderResponse.ErrorNegocio.Estado ===
        "ok"
      ) {
        setNotificacion(SUCCESS_MESSAGE);
        setAceptarExito(true);
        handleShow();
      } else {
        setAceptarExito(false);
        setNotificacion(ERROR_MESSAGE);
        handleShow();
      }
    }

    isLoading(false);
  };

  const doValidarPreRegistro = async (IdPre: string) => {
    const ValidarPreRegistroRestDO: ValidarPreRegistroRest_Entrada =
      builtValidarPreRegistroInput(IdPre);

    let par = ValidarPreRegistroRest_Parametros(ValidarPreRegistroRestDO);
    let ValidarPreRegistroRestRespuesta: ValidarPreRegistroRest_Respuesta =
      await ConsultaWS(par);

    let status =
      ValidarPreRegistroRestRespuesta.DbValidarPreRegistroSelOutputCollection
        .DbValidarPreRegistroSelOutput[0].ESTATUS;

    if (
      ValidarPreRegistroRestRespuesta.EBMHeaderResponse &&
      ValidarPreRegistroRestRespuesta.EBMHeaderResponse.ErrorTecnico.code ===
        "ok"
    ) {
      switch (status) {
        case "VIGENTE":
          // setNotificacion(VIGENTE_MESSAGE);
          setDisable(false);
          handleClose();
          break;

        case "EXPIRADO":
          setNotificacion(EXPIRADO_MESSAGE);
          setDisable(true);
          handleShow();
          break;

        case "PROCESADO":
          setNotificacion(PROCESADO_MESSAGE);
          setDisable(true);
          handleShow();
          break;
        default:
          setNotificacion(GENERIC_ERROR_MESSAGE + " " + status);
          setDisable(true);
          handleShow();
          break;
      }
    }
  };

  const handleRecaptcha = useCallback((token: string | null) => {
    setCapchaToken(token || "");
    validateURL();
  }, []);

  return (
    <>
      <Container className={styles.container}>
        <Loading isLoading={loading} />

        <div className={styles["confirmMessage"]}>
          <ConfirmMessage
            status={statusError}
            message={message}
            showAlert={showAlert}
          />
        </div>

        {loading === true ? <BarraLoader /> : <></>}

        <Row className={styles["rowContainer"]}>
          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            className={styles["registrarForm"]}
          >
            <Form className={styles.estiloForm}>
              <img src={imagenURI} className={styles.logo} />
              <hr className={styles["line"]} />

              <Row>
                <h4
                  className={
                    "text-md text-center " + styles["textGradient"] + " mb-2"
                  }
                >
                  <span>Ingresa y confirma tu nueva contraseña</span>
                </h4>
              </Row>

              <Form.Group
                className={styles.label + " mb-1"}
                controlId="formBasicContrasenia"
              >
                <Form.Label
                  style={{ marginBottom: "0px" }}
                  className={styles.estiloLabels}
                >
                  Contraseña
                </Form.Label>

                <Form.Control
                  type="password"
                  onBlur={(e) => setFieldValue(e.target.value, "password")}
                  onChange={(e) => setFieldValue(e.target.value, "password")}
                  disabled={disable}
                  value={password}
                />
                {validaPasswordVacio ? (
                  <Form.Label>
                    {" "}
                    <span
                      className={styles.estiloLabels + " " + styles.mensaje}
                    >
                      {" "}
                      {vPasswordMessage}
                    </span>{" "}
                  </Form.Label>
                ) : (
                  <Form.Label>
                    <span></span>
                  </Form.Label>
                )}
              </Form.Group>

              <Form.Group
                className={styles.label + " mb-1"}
                controlId="formBasicConfirmarContrasenia"
              >
                <Form.Label
                  style={{ marginBottom: "0px" }}
                  className={styles.estiloLabels}
                >
                  Confirmar Contraseña
                </Form.Label>

                <Form.Control
                  type="password"
                  onBlur={(e) =>
                    setFieldValue(e.target.value, "confirmPassword")
                  }
                  onChange={(e) =>
                    setFieldValue(e.target.value, "confirmPassword")
                  }
                  disabled={disable}
                  value={confirmPassword}
                />
                {validaConfirmarContraseniaVacio ? (
                  <Form.Label>
                    {" "}
                    <span
                      className={styles.estiloLabels + " " + styles.mensaje}
                    >
                      {" "}
                      {vConfirmPwdMessage}
                    </span>{" "}
                  </Form.Label>
                ) : (
                  <Form.Label>
                    <span></span>
                  </Form.Label>
                )}
              </Form.Group>
              <Row>
                <div className="flex flex-col justify-center items-center">
                  {process.env.REACT_APP_CAPTCHA_KEY && (
                    <ReCAPTCHA
                      ref={captchaRef}
                      type="image"
                      sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                      onChange={handleRecaptcha}
                    />
                  )}
                  {/*onChange={(value) => setValue('captcha', value)} */}
                  {/*errors.captcha?.message && <p className='text-sm font-light mb-2 text-[#ef4444]'>{errors.captcha.message}</p>*/}
                </div>
              </Row>

              <Row>
                <Col className={styles["buttonContainer"]}>
                  <Button
                    variant="btn btn-primary"
                    className={styles.boton}
                    disabled={!capchaToken || disable} // Se deshabilita si no hay CAPTCHA validado
                    onClick={handleSubmit}
                  >
                    Completar Registro
                  </Button>
                </Col>
              </Row>

              <Row style={{ marginTop: "1vw" }}>
                <Col lg={11} xl={11} md={11} sm={11} xs={11}>
                  <div>
                    <span className={styles.estiloLabels}>
                      {" "}
                      Elige una contraseña segura con las siguientes
                      caracteristicas
                    </span>
                    <ul>
                      <li className={styles.estiloLabels}>
                        Al menos 8 y maximo 20 caracteres
                      </li>
                      <li className={styles.estiloLabels}>
                        Al menos uno mayúscula
                      </li>
                      <li className={styles.estiloLabels}>
                        Al menos uno minúscula
                      </li>
                      <li className={styles.estiloLabels}>
                        Al menos un dígito
                      </li>
                      <li className={styles.estiloLabels}>
                        Al menos un caracter especial:{" "}
                        <span>
                          {'! # % * ( ) - _ = + " :: ? [ 16 . < > $ @'}
                        </span>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {status.show && (
                <p style={{ color: status.color }}>{status.message}</p>
              )}
            </Form>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            className={styles["imageContainer"]}
          >
            <img src={sideImage} className={styles["sideImage"]} />
          </Col>
        </Row>
      </Container>

      <Modal
        className={styles.contenedorModal}
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {" "}
        <Modal.Header className="border-0" closeButton></Modal.Header>{" "}
        <Modal.Body>
          <Form>
            <img src={imagenURI} className={styles.logo} />
          </Form>
          <h1
            className={
              styles["text-center"] +
              " " +
              styles["text-3xl"] +
              " " +
              styles["font-medium"] +
              " " +
              styles["tracking-widest"] +
              " " +
              styles["titleModal"] +
              " pt-5"
            }
          >
            Información
          </h1>
          <p className={styles["text-center"] + " pt-4"}> {notificacion} </p>
          <div className={styles["divButton"]}>
            <Button
              className={styles["aceptarButton"]}
              onClick={aceptarExito ? handleRedirect : handleClose}
            >
              <b>Aceptar</b>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmarRegistroCuenta;
